function a(e) {
  return e["aria-label"] || e["aria-labelledby"] ? e : { "aria-hidden": !0, ...e };
}
export {
  a as g
};
//# sourceMappingURL=getAccessibleIconProps-DwOSrVuG.mjs.map
